class FormattingRuleVM {
    id: number;
    scales: Array<FormattingRuleScale>;
    config: FormattingRuleConfig;
    icons: { [key: number]: string; };

    constructor(data) {
        this.id = data.id;
        this.scales = createInstancesWithParameterFirst(FormattingRuleScale, null, data.scales);
        this.config = new FormattingRuleConfig(data.config);
        this.icons = data.icons;
    }
}